import React, { useState, useRef, useEffect } from "react";
import "./Navbar.scss"
import clock from "../../assets/clock.svg"
import fb from "../../assets/fb.svg"
import insta from "../../assets/insta.svg"
import x from "../../assets/x.svg"
import yt from "../../assets/yt.svg"
import loc from "../../assets/loc.svg"
import logo from "../../assets/logo.png"
import cart from "../../assets/cart.svg"
import arrow from "../../assets/down-arrow.svg"
import more from "../../assets/more.svg"
import Button from "../Button/Button";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";



const Navbar = ({ setIsMenuOpen }) => {
    const [showPopup, setShowPopup] = useState("")
    const history = useHistory()
    const dispatch = useDispatch()
    const pages = useSelector((state) => state.companyData.pages)
    const company = useSelector((state) => state.companyData.company);

    const page = pages?.find((page) => page.PageId === "navbar")

    const leftComponent = page?.Components?.find((component) => component?.ID === "Hoppers-Navbar")?.Props ?? null
    const linksComponent = page?.Components?.find((component) => component?.ID === "Hoppers-Navbar-link")?.Data ?? []
    const buttonComponent = page?.Components?.find((component) => component?.ID === "Hoppers-Navbar-button")?.Props ?? null

    const popoverRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                setShowPopup("");
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPopup]);
    return (
        <div className="HoppersCafeNavbar">
            <div className="HoppersCafeNavbar-topbar">
                <div className="HoppersCafeNavbar-topbar-left">
                    <img className="HoppersCafeNavbar-topbar-left-ic"
                        alt=""
                        src={clock} />
                    <div className="HoppersCafeNavbar-topbar-left-highlight">opening hours : </div>
                    <div className="HoppersCafeNavbar-topbar-left-text">
                        6.00 AM - 2.00 PM | 3.00 PM - 10.00PM
                    </div>
                </div>
                <div className="HoppersCafeNavbar-topbar-center">
                    {company?.SocialMedias
                        ?.facebook && company?.SocialMedias
                            ?.facebook !== "" && <img className="HoppersCafeNavbar-topbar-center-ic"
                                alt=""
                                src={fb}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.facebook, '_blank')
                                }} />}
                    {company?.SocialMedias
                        ?.x && company?.SocialMedias
                            ?.x !== "" && <img className="HoppersCafeNavbar-topbar-center-ic"
                                alt=""
                                src={x}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.x, '_blank')
                                }} />}
                    {company?.SocialMedias
                        ?.instagram && company?.SocialMedias
                            ?.instagram !== "" && <img className="HoppersCafeNavbar-topbar-center-ic"
                                alt=""
                                src={insta}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.instagram, '_blank')
                                }} />}
                    {company?.SocialMedias
                        ?.youtube && company?.SocialMedias
                            ?.youtube !== "" && <img className="HoppersCafeNavbar-topbar-center-ic"
                                alt=""
                                src={yt}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.youtube, '_blank')
                                }} />}
                </div>
                <div className="HoppersCafeNavbar-topbar-right">
                    <img className="HoppersCafeNavbar-topbar-right-ic"
                        alt=""
                        src={loc} />
                    <div className="HoppersCafeNavbar-topbar-right-highlight">Location : </div>
                    <div className="HoppersCafeNavbar-topbar-right-text">25 Station Street, Kirkby-in-Ashfield</div>
                </div>
            </div>
            <div className="HoppersCafeNavbar-btmbar">
                {leftComponent && <img className="HoppersCafeNavbar-btmbar-left"
                    alt=""
                    src={leftComponent?.src}
                    onClick={() => {
                        history.push(leftComponent?.href)
                    }}
                />}
                <div className="HoppersCafeNavbar-btmbar-center">
                    {linksComponent.map((link, key) => {
                        return (
                            <div key={key}
                                onClick={() => {
                                    if (link?.subMenu && link?.subMenu.length > 0) {
                                        setShowPopup(link?.title)
                                    } else {
                                        if (link?.href) {
                                            if (link?.href?.includes("https://")) {
                                                if (link?.href && link?.href !== "") {
                                                    window.open(link?.href, '_blank')
                                                }
                                                else {
                                                    dispatch(setIsComing(true))

                                                }
                                            } else {
                                                history.push(link?.href)
                                            }
                                        } else {
                                            dispatch(setIsComing(true))
                                        }
                                    }
                                }} className={`HoppersCafeNavbar-btmbar-center-link ${window.location.pathname === link?.href ? "HoppersCafeNavbar-link-selected " : ""}`}>
                                {link?.title}
                                {link?.subMenu && link?.subMenu.length > 0 && <img
                                    alt="" src={arrow} />}
                                {showPopup !== "" && showPopup === link.title && <div
                                    className="navbar-popup-cont"
                                    ref={popoverRef}>
                                    {link?.subMenu?.map((submenu, key) => {
                                        return (<div key={key}
                                            className="navbar-popup-cont-item"
                                            onClick={() => {
                                                history.push(submenu?.href)
                                            }}>{submenu.title}
                                        </div>)
                                    })}</div>}
                            </div>
                        )
                    })}
                </div>
                <div className="HoppersCafeNavbar-btmbar-mobright">
                    {/* <div
                        className="HoppersCafeNavbar-btmbar-mobright-ic"
                    >
                        <img
                            className="HoppersCafeNavbar-btmbar-mobright-ic-img"
                            alt=""
                            src={cart} />
                    </div> */}
                    <div
                        className="HoppersCafeNavbar-btmbar-mobright-ic"
                        onClick={() => {
                            setIsMenuOpen(true)
                        }}
                    >
                        <img
                            className="HoppersCafeNavbar-btmbar-mobright-ic-img"
                            alt=""
                            src={more} />
                    </div>
                </div>
                {buttonComponent && <div className="HoppersCafeNavbar-btmbar-right">
                    {/* <div
                        className="HoppersCafeNavbar-btmbar-right-ic"
                    >
                        <img
                            className="HoppersCafeNavbar-btmbar-right-ic-img"
                            alt=""
                            src={cart} />
                        <div
                            className="HoppersCafeNavbar-btmbar-right-ic-count">0</div>
                    </div> */}

                    <Button text={buttonComponent?.buttonText}
                        width={"max-content"}
                        onClick={() => {
                            if (buttonComponent?.href && buttonComponent?.href !== "") { window.location.href = buttonComponent?.href }
                            else {
                                dispatch(setIsComing(true))
                            }
                        }} />
                </div>}
            </div>
        </div>
    )
}
export default Navbar